import React from 'react';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';
import { ApiFormationsEventIdGet200ResponseDataFormationsAwayInnerInner } from '@/api/livescore/generated';
import { convertAlpha } from '@/utils/countryCode';
import { cn } from '@/utils/cn';
import Image from 'next/image';
import LivescoreEntityLink from '@/components/atoms/LivescoreEntityLink/LivescoreEntityLink';

const SubstitutesItem = ({
  player,
  reverse,
}: {
  player: ApiFormationsEventIdGet200ResponseDataFormationsAwayInnerInner;
  reverse?: boolean;
}) => {
  const aplha = player.country_code ? convertAlpha(player.country_code) : '';

  return (
    <li>
      <LivescoreEntityLink
        href={`/livescore/player/${player.slug ? player.slug : player?.id?.split(':')[2]}`}
        className={cn('flex items-center gap-1', reverse ? 'flex-row-reverse' : '')}
      >
        {player.jersey_number ? <p className="text-[8px] sm:text-[11px]">{player.jersey_number}</p> : null}
        {aplha ? (
          <div className="w-[7px] h-[7px] sm:w-[10px] sm:h-[10px] rounded-full relative overflow-hidden">
            <Image
              src={`https://flagcdn.com/${aplha.toLocaleLowerCase()}.svg`}
              alt={aplha}
              layout="fill"
              objectFit="cover"
            />
          </div>
        ) : null}
        <p className="text-[8px] sm:text-[11px] font-semibold">{player.name}</p>
      </LivescoreEntityLink>
    </li>
  );
};

const Substitutes = () => {
  const { substitutes } = useLivescoreMatch();

  if (!substitutes?.home.length && !substitutes?.away.length) {
    return null;
  }

  return (
    <div className="mt-4 text-black dark:text-white">
      <h4 className="text-xs mb-2.5">Rezerwowi</h4>
      <div className="flex justify-between">
        <ul className="pl-0 list-none space-y-2 sm:space-y-2.5">
          {substitutes?.home.map((player) => (
            <SubstitutesItem key={player.id} player={player} />
          ))}
        </ul>
        <ul className="pl-0 list-none space-y-2 sm:space-y-2.5">
          {substitutes?.away.map((player) => (
            <SubstitutesItem key={player.id} player={player} reverse />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Substitutes;
